module.exports = {
      id: "Calculate Copy-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/simulator/sprite.svg#Calculate Copy-usage",
      toString: function () {
        return this.url;
      }
    }